export const skillsData = [
  "Java",
  "Python",
  "C",
  "HTML",
  "CSS",
  "Javascript",
  "React",
  "SQL",
  "Git",
  "Github",
  "Linux",
  "Kali Linux",
  "Microsoft Azure",
  "Android App Development",
  "Web Development",
  "Cybersecurity",
  "Problem Solving",
  "Adaptability",
  "Communication",
  "Leadership",
  "Teamwork",
  "Time management"
];
